import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { ExternalMyTeamModel } from 'src/app/components/master-data/user-form-external/external-my-team.model';
import { SendInviteComponent } from 'src/app/components/snackbars/send-invite/send-invite.component';
import { UserModel } from 'src/app/models/common/usermodel';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
    myAccountTabs = {
        my_profile: 0,
        my_team: 1,
        notification_preferences: 2,
        my_preferences: 3,
        privacy_security: 4,
        devices: 5,
        login_activity: 6,
    }

    @Input()
    selectedExternalUser = new BehaviorSubject<ExternalMyTeamModel>(null);

    selectedTab = 0;
    open: string = "sidepanel";
    Canvas: string = "Canvas";
    isEditable: boolean = true;
    defaultErrorObj: any = {};
    selectedUser: UserModel;
    refreshTable = new Subject();
    isCustomer: boolean;

    defaultUserObj: UserModel = {
        id: null,
        role: null,
        designation: null,
        manager: null,
        first_name: null,
        last_name: null,
        email: null,
        department: null,
        cover_picture: null,
        linked_in_profile: null,
        e_sign: null,
        picture: null,
        region: null,
        theme: 'default',
        created_at: null,
        updated_at: null,
        created_by: null,
        updated_by: null,
        is_active: true,
        mobile_number: null,
        whatsapp_number: null,
        gender: 'Other',
        date_of_birth: null,
        anniversary_date: null,
        external_profile_id: null,
    }

    closeUserSidePanel() {
        // document.getElementById("mySidepanel")!.style.width = "0";
        // document.getElementById("mySidepanel")!.style.boxShadow = "none";
        this.open = " sidepanel";
        this.Canvas = " Canvas ";
        this.selectedUser = { ...this.defaultUserObj };
        this.isEditable = true;
    }

    setCanvas(canvasData: any) {
        this.Canvas = canvasData;
    }
    setOpen(openData:any){
        this.open= openData;
    }

    addUser(className: string) {
        this._snackBar.openFromComponent(SendInviteComponent, {
            duration: 20000,
            panelClass: [className]
        });
    }

    constructor(private _snackBar: MatSnackBar,
        private authService: AuthService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();

        this.route.queryParams.subscribe(params => {
            if ('tab' in params) {
                this.selectedTab = this.myAccountTabs[params['tab']];
            }
        })
    }

    onUserChange(user: UserModel) {
        this.closeUserSidePanel();
        this.refreshTable.next("Refresh");
    }

    editUser(user) {
        this.selectedUser = JSON.parse(JSON.stringify(user));
    }

    editExternalUser(externalUser: ExternalMyTeamModel) {
        this.selectedExternalUser.next(externalUser)
    }

    clearError(error) {
        this.defaultErrorObj = error;
    }

    editable(event) {
        this.isEditable = event;
    }
}
